module.exports = __webpack_public_path__ + "img/流体力学1_1.143d4803.jpg";